import React, { useEffect, useState } from 'react';
import { withRouter } from '../withRouter';
import { connect, useSelector } from 'react-redux';
import { PaymentElement, Elements, useStripe, useElements } from "@stripe/react-stripe-js";
import { Spinner, Alert } from 'react-bootstrap';
import { loadStripe } from "@stripe/stripe-js";
import StripeService from "services/stripe.service";
import Analytics from "analytics";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import styles from 'components/BuyForLobbyModal/BuyForLobbyModal.module.scss';
import PricingFunctions from '../../common/PricingFunctions';
import DotLoader from 'components/Utlility/DotLoader';

function BuyForLobbyModal(props) {
    const [enabled] = useState(true);
    const [show, setShow] = useState(true);
    const [email, setEmail] = useState(null);
    const [intentError, setError] = useState(null);
    const [clientSecret, setClientSecret] = useState(null);
    const [loadingCheckout, setLoadingCheckout] = useState(false);
    const [stripeOptions, setStripeOptions] = useState(null);
    const [stripePromise, setStripePromise] = useState(null);
    const [processingPayment, setProcessingPayment] = useState(false);
    const [promoCode, setPromoCode] = useState('');
    const [promoError, setPromoError] = useState(null);
    const [promoSuccess, setPromoSuccess] = useState(null);
    const [showPromoField, setShowPromoField] = useState(false);
    const [actualPrice, setActualPrice] = useState(null);
    const stripeAppearance = { theme: 'flat', variables: {} };
    const { countryCode, } = useSelector(state => state.pricing);

    var pollPaymentKeys = null;

    useEffect(() => {
        setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_KEY));
        setEmail(props.hostUser?.email ?? props.hostUser?.sub);
        createIntent(null, () => setShowPromoField(true));
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (show) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';
        return () => {
            document.body.style.overflow = '';
            clearInterval(pollPaymentKeys);
        };
    }, [show]);

    const createIntent = (coupon, callback) => {
        setLoadingCheckout(true);
        const items = [{ ...props.game, quantity: 1 }];
        const currency = PricingFunctions.getCurrency(countryCode);
        console.log("Country Code : ", countryCode);
        StripeService.createPaymentIntent(items, coupon, props.hostUser?.sub, "", currency, countryCode)
            .then((res) => {
                setLoadingCheckout(false);
                setClientSecret(res.data.clientSecret);
                setStripeOptions({
                    clientSecret: res.data.clientSecret,
                    appearance: stripeAppearance,
                    loader: "auto"
                });
                setActualPrice(res.data.cartTotalRaw);
                Analytics.beginCheckout(items, currency, res.data.cartTotalRaw, coupon);
                setPromoError(null);
                if (callback) callback();
            })
            .catch((err) => {
                setError(err);
                setLoadingCheckout(false);
                if (callback) callback();
            });
    };

    function onPromoFromSubmit(e) {
        if (e) e.preventDefault();
        checkPromoCode()
    }

    function checkPromoCode() {
        setLoadingCheckout(true);
        setPromoError(null);
        setPromoSuccess(null);
        const productIds = [props.game.productId];
        StripeService.checkPromotionCode(promoCode, productIds)
            .then((res) => {
                if (res.data.valid === true) {
                    console.log(res.data)
                    setPromoSuccess(`Promo applied for ${res.data.percentOff}% off!`);
                    setPromoError(null);
                    setShowPromoField(false);
                    createIntent(promoCode);
                } else {
                    setPromoError(res.data.message);
                    setPromoSuccess(null);
                    setLoadingCheckout(false);
                }
            }).catch((err) => {
                setPromoError(err.message);
                setPromoSuccess(null);
                setLoadingCheckout(false);
            });
    }

    function getPrice(game) {
        const basePrice = PricingFunctions.getGamePricing(countryCode, game);
        if (actualPrice) {
            const isDiscount = actualPrice < basePrice.raw;
            return (
                <span style={isDiscount ? { color: 'lightgreen' } : {}}>
                    {basePrice.currency + actualPrice}
                </span>
            );
        }
        return <span>{basePrice.display}</span>;
    }

    function handlePurchased(paymentIntent) {
        setProcessingPayment(true);

        pollPaymentKeys = setInterval(() => pollForPaymentKeys(paymentIntent), 4000); // Poll every 4 seconds
        //StripeService.verifyAndGenerateActivationCode(
        //    paymentIntent.id,
        //    email,
        //).then((res) => {
        //    let currency = PricingFunctions.getCurrency(countryCode);
        //    Analytics.purchaseComplete(res.data.orderProducts, currency, res.data.total, paymentIntent.id, res.data.coupon);
        //    if (props.onPurchased) props.onPurchased();
        //    setShow(false); // Close modal

        //    setProcessingPayment(false);
        //}).catch((err) => {
        //    //setError(err);
        //    //setProcessingPayment(false);

        //});
    }

    const pollForPaymentKeys = (paymentIntent) => {
        console.log("Polling with payment intent id : ", paymentIntent.id);

        StripeService.getPaymentKeys(
            paymentIntent.id,
            email,
        ).then((res) => {
            //let currency = PricingFunctions.getCurrency(props.pricing.countryCode);
            Analytics.purchaseComplete(res.data.orderProducts, res.data.currency, res.data.total, paymentIntent.id, res.data.coupon);
            if (props.onPurchased) props.onPurchased();
            setShow(false); // Close modal

            setProcessingPayment(false);
            clearInterval(pollPaymentKeys);
        }).catch((err) => {
            //setError(err);
            //setProcessingPayment(false);
        });
    }

    if (!enabled || !show) return null;

    return (
        <div className={`${styles.screenOverlay} ${show && styles.show} ${props.styles}`}>
            <div className={styles.screenOverlayBG}></div>
            <div className={styles.modalContainer}>
                <div className={styles.modal} style={{ position: 'relative' }}>
                    <button
                        className={styles.closeButton}
                        onClick={props.onClose}
                        disabled={processingPayment}
                        aria-label="Close"
                        type="button">

                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <h1 className={styles.title}>Buy Now and Play!</h1>
                    <div className={`${styles.background} ${styles.columbs}`}>
                        <div className={`${styles.columb} ${styles.center}`}>
                            <div className={styles.priceBanner} style={{ background: props.game?.meta.cardPriceColour }}>
                                {getPrice(props.game)}
                            </div>
                            <img className={styles.gameCard} src={props.game?.meta.tinyCard} alt="required" />
                        </div>
                        <div className={`${styles.columb}`}>
                            <div className={styles.details}>
                                <h3>{props.game?.name}</h3>
                                <p>{props.game?.description}</p>
                            </div>
                        </div>
                    </div>
                    {(!props.auth.user || props.auth.user.email !== email) ?
                        <Alert variant={"danger"} className={styles.message}>
                            <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: 8 }} />
                            <span>
                                NOTE - You are buying this game for:<br /><span style={{ fontWeight: "bold" }} >{email}</span>
                            </span>
                        </Alert>
                        : <br />
                    }
                    {showPromoField && (
                        <Form onSubmit={onPromoFromSubmit}>
                            <Form.Group className="mb-3">
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        placeholder="Promo code"
                                        value={promoCode}
                                        onChange={e => {
                                            setPromoCode(e.target.value.toUpperCase());
                                            setPromoSuccess(null);
                                            setPromoError(null);
                                        }}
                                        className={styles.input}
                                        disabled={loadingCheckout || processingPayment}
                                        autoComplete="off"
                                    />
                                    <button
                                        type="button"
                                        className={`btn ${styles.promoButton}`}
                                        onClick={checkPromoCode}
                                        disabled={loadingCheckout || processingPayment || !promoCode}
                                    >
                                        Apply
                                    </button>
                                </InputGroup>
                            </Form.Group>
                        </Form>
                    )}
                    {promoError && (
                        <Alert variant="danger" className={styles.promoAlert}>
                            {promoError}
                        </Alert>
                    )}
                    {promoSuccess && (
                        <Alert variant="success" className={styles.promoAlert}>
                            {promoSuccess}
                        </Alert>
                    )}
                    {intentError && (
                        <Alert variant="danger" className={styles.promoAlert}>
                            { intentError.message || intentError.toString() }
                        </Alert>
                    )}
                    {clientSecret && stripeOptions && !loadingCheckout && (
                        <Elements stripe={stripePromise} options={stripeOptions}>
                            <StripePaymentForm
                                onSuccess={handlePurchased}
                                processingPayment={processingPayment}
                            />
                        </Elements>
                    )}
                    {(loadingCheckout || processingPayment) && !promoError && (
                        <div className={styles.spinnerOverlay}>
                            <DotLoader size="medium" variant="dark" />
                        </div>
                    )}
                </div>
            </div>
        </div >
    );
}

function StripePaymentForm({ onSuccess, processingPayment }) {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [formComplete, setFormComplete] = useState(false);
    const paymentElementOptions = { layout: "tabs" };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setProcessing(true);
        setError(null);

        if (!stripe || !elements) {
            setProcessing(false);
            return;
        }

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {},
            redirect: "if_required"
        });

        setProcessing(false);

        if (error) {
            setError(error.message);
        } else if (paymentIntent && paymentIntent.status === "succeeded") {
            onSuccess && onSuccess(paymentIntent);
        }
    };

    // Listen for changes in the PaymentElement to check if the form is complete
    const handleElementChange = (event) => {
        setFormComplete(event.complete);
    };

    return (
        <form onSubmit={handleSubmit} style={{ opacity: (processing || processingPayment) ? 0.6 : 1, pointerEvents: (processing || processingPayment) ? "none" : "auto" }}>
            <PaymentElement
                options={paymentElementOptions}
                disabled={processing || processingPayment}
                onChange={handleElementChange}
            />
            {error && <div style={{ color: "red" }}>{error}</div>}
            <div className={styles.buttons}>
                <button
                    type="submit"
                    disabled={processing || processingPayment || !stripe || !formComplete}
                    className={`${styles.button} ${styles.alternate}`}
                    style={{ margin: "0 10px" }}
                >
                    {(processing || processingPayment) ? "Processing..." : "Buy Now"}
                </button>
            </div>
        </form>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    pricing: state.pricing,
    cart: state.cart,
    room: state.room
});

export default connect(mapStateToProps)(withRouter(BuyForLobbyModal));
